import {
  Add,
  ArrowBackIos,
  ArrowForwardIos,
  AssignmentOutlined,
  Close,
  Print as PrintIcon
} from '@mui/icons-material';
import FullscreenIcon from '@mui/icons-material/Fullscreen';
import FullscreenExitIcon from '@mui/icons-material/FullscreenExit';
import {
  Alert,
  Badge,
  FormControlLabel,
  IconButton,
  Modal,
  Snackbar,
  Switch
} from '@mui/material';
import { styled as muiStyled } from '@mui/material/styles';
import * as Sentry from '@sentry/react';
import CommonEbookTooling from "components/ebook";
import GraphicOrganizerAssignments from 'components/GraphicOrganizerAssignment';
import GraphicAssignmentPreview from 'components/GraphicOrganizerAssignmentPreview';
import LinkList from "components/HyperlinkViewer";
import Interaction from "components/Interaction";
import LessionPlanPrinter from "modules/lessonPlan/teacher/LessionPlanPrinter";
import Loading from "components/Loading";
import BubbleNotes from "components/Notes";
import AssignmentForm from "features/forms/AssignmentForm";
import BingoModal from "modules/bingoModule";
import OnegameModals from 'components/OneGame/OneGameModal';
import ExtensionActivitiesTooling from "modules/extraResource/teacher";
import "moment-timezone";
import React, { useEffect, useMemo, useRef, useState } from "react";
import { connect, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useReactToPrint } from "react-to-print";
import COLOR from "utils/constants/color";
import { Col, Row } from "antd";
import { TeacherStrategies, VideoSupport } from "components/ebook/EbookVideos";
import OnestudyModals from "components/OneStudy/OneStudyModal";
import PrintAction from "components/PrintAction";
import useMobileDeviceDetection, { useMobileDetect, useTabletDetection } from "containers/chat/hooks";
import PageEditor from "features/forms/PageEditor";
import { filter, find, findIndex, get, has, slice } from "lodash";
import SentenceViewTooling from "modules/sentenceStarter/teacher/sentenceViewTooling";
import { useExams } from "store/exams/selectors";
import { useServertime } from "store/servertime/selectors";
import { useWorkSheetSelector } from "store/worksheet/selectors";
import styled from "styled-components";
import { useFullScreen } from "utils/context/FullScreenProvider";
import { useSideDrawer } from "utils/context/SideDrawerProvider";
import { useShareNotification } from "utils/methods/firebaseShareAssignment";
import QuizHandler from "./quiz/QuizHandler";
import { getBookData, getPageData, modifyAssignmentForStudent, sortByCustomType } from "utils/lib/ebookHelper";
import { useClassTogglePermission, useCurrentOrgPermission, useOrgStandardCodes, useOrgTimezone } from "store/organizations/selectors";
import { useBookOrder } from "store/books/selectors";
import { useIsAdditionalBook } from "utils/methods/functions";
import { useAnswerView, useMainbookView, useSentenceView, usePDFView, useActivityStandardsView } from "store/main_book_popup/selectors";
import { useAlert } from 'components/UI/alertSakeBar/alertProvider';
import WorkSheetModal from "modules/workSheet";
import AssignmentsComponent from 'modules/assignments';
import TeachersWorkSheet from 'modules/workSheet/TeachersWorkSheet';
import TeacherEditionList from 'modules/teacherEdition/teacher/TeacherEditionViewer';
import usePopUpAtOnce from 'components/hooks/usePopUpAtOnce';
import LessonPlan from 'modules/lessonPlan/teacher';
import { useMatchMakingView } from 'store/main_book_popup/selectors';
import { useLearningModuleCount } from 'store/bingo/selectors';
import { isErrorContent } from "utils/methods/storyContentValidation";
import { useUI } from 'store/UI/selectors';
import EngagePgEditor from 'modules/engageFeature/teacher/enagePgEditor';
import { useBookDataUnits } from 'components/hooks/books/useBookDataUnits';
import SoyHistoriasIconUpdated from "../utils/assets/images/SoyHistoriasIconUpdated.svg";
import GrammerIconDrill from "../utils/assets/images/GrammerIconDrill.svg";
import PresentationIcon from "../utils/assets/images/PresentationIcon.svg";
import GenerateTestIcon from "../utils/assets/images/GenerateTestIcon.svg";
import ShowStandardIcon from "../utils/assets/images/ShowStandardIcon.svg";
import AiActivityIcon from "../utils/assets/images/AiActivityIcon.svg";
import useIsExamActive from 'components/hooks/books/useIsExamActive';
import SentryWrap from 'components/Sentry';
import AssignmentBuilderTool from 'components/AssignmentBuilder/AssignmentBuilderTool';
import { useStandards } from 'store/story/selectors';
import { filterStateStandardByEnabledStates } from 'utils/lib/standardHelper';


//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------

const Page = styled.div`
  align-items: center;
  color: ${COLOR.black100};
  display: flex;
  flex-direction: row;
  font-size: 16px;
  font-weight: 600;
  white-space: nowrap;
  width: 80px;
`;

const Section = styled.div`
  border-bottom: 1px dashed ${COLOR.black700};
  padding: 0px 0px 24px;
  margin-bottom: 16px;
  position: relative;
  &:first-child {
    border-bottom: none;
    margin-bottom: 0px;
    padding: 0px;
  }

  &:last-child {
    border-bottom: none;
    padding-bottom: 0px;
  }
`;

const SectionHeader = styled.span`
  align-items: center;
  color: ${COLOR.black200};
  display: flex;
  flex-direction: row;
  font-size: 10px;
  font-weight: 600;
  justify-content: space-between;
  margin-bottom: 8px;
  text-transform: uppercase;
  width: 100%;
  margin-top:10px;
`;


const Toolbar = styled.div`
  align-items: center;
  border-bottom: 1px solid ${COLOR.black600};
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: space-between;
  width: 100%;
`;

const Wrap = styled.div`
  align-items: flex-start;
  border-bottom:${p => p.empty ? '0px' : '1px'} dashed ${COLOR.black800};
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  padding: ${p => p.empty ? '0px' : '0px 0px'};
  padding-left: 10px;
  padding-right: 10px;
  padding-top:${p => p.empty ? '0px' : '0px'};
  padding-bottom:${p => p.empty ? '0px' : '0px'};
  flex-wrap: wrap;
  justify-content: start;
`;

const Wrapper = styled.div`
  height: 100%;
  // min-height: 600px;
  min-height: 955px;
  width: 100%;
  background-color: #e0e0e0;
  position: relative;

     @media (max-width: 1367px){
        min-height:unset !important;
    }
  
`;
// overflow: hidden;

const CenterContainer = styled.div`
  align-items: center;
  display: flex;
  height: 100%;
  justify-content: center;
  width: 100%;
`;

const LessionPlan = styled.button`
    background-image: linear-gradient(to right, rgb(189,38,95), rgb(217,87,61));
    // border: none;
    border:1px solid #015ECC;
    cursor: pointer;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    height: 27.2px;
    color: white;
    z-index: 1;
    padding: 1px;
    font-size: 12.1px;
    font-weight: 400;
    margin-left:4px;

    @media only screen and (max-width: 1367px){
      margin-top:5px;
    }

      @media (max-width: 992px) {
        // display:none;
      }
}
`;
const LessionPlanInner = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  background-color: transparent;
  border: 1px solid #fff;
  padding-left: 5px;
  padding-right: 5px;
`;
const AssignmentPlan = styled.button`
    // background-image: linear-gradient(to right,${COLOR.indigo500}, ${COLOR.indigo600});
    background-color: #020A52;
    // border: none;
    border:1px solid #020A52;
    cursor: pointer;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    height: 27.2px;
    color: white;
    z-index: 1;
    padding: 1px;
    font-size: 12.1px;
    font-weight: 400;
    margin-left: 4px;

    @media only screen and (max-width: 1367px){
      margin-top:5px;
    }
}
`;
const DummyBtn = styled.button`
    background-color: transparent;
    // cursor: pointer;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    height: 27.2px;
    z-index: 1;
    padding: 1px;
    font-size: 12.1px;
    font-weight: 400;
    margin-left: 4px;
    color:transparent;
    border-width:0px;
    @media only screen and (max-width: 1367px){
      margin-top:5px;
    }
}
`;
const AssignmentPlanLink = styled.span`
    // background-image: linear-gradient(to right,${COLOR.indigo500}, ${COLOR.indigo600});
    background-color: #020A52;
    // border: none;
    border:1px solid #020A52;
    cursor: pointer;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    height: auto;
    color: white;
    z-index: 1;
    padding: 1px;
    font-size: 12.1px;
    font-weight: 400;
    margin-left: 4px;

    @media only screen and (max-width: 1367px){
      margin-top:5px;
    }
}
`;

const AssignmentPlanInner = styled.div`
  display: flex;
  // flex-direction: column;
  flex-direction:row;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  background-color: transparent;
  border: 1px solid #fff;
  padding-left: 6px;
  padding-right: 6px;
`;

const AssignmentPlanInnerLink = styled.div`
  display: flex;
  // flex-direction: column;
  flex-direction:row;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: auto;
  background-color: transparent;
  border: 1px solid #fff;
  padding-left: 6px;
  padding-right: 6px;
`;

const LearnPlanWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  background-color: transparent;
  overflow: hidden;
`;
const PlannerWrapper = styled.div`
  width: max-content;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  flex-wrap: wrap-reverse;
`;

const LessionPlanContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 75%;
  // height: 90%;
  height: auto;
  position: relative;
  justify-content: center;
  padding: 20px;
  background-color: white;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  @media Screen and (min-width: 1200px) {
    width:50%;
  }
`;
const CloseBtn = styled.div`
  background-color: rgb(204, 80, 71);
  border: none;
  cursor: pointer;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  position: absolute;
  top: 10px;
  right: 10px;
  color: white;
  z-index: 1;
`;

const Images = styled.img`
  background-color: ${COLOR.white};
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.19), 0 6px 6px rgba(0, 0, 0, 0.23);
  object-fit: cover;
  height: 600px;
  @media (max-width: 768px) {
    height: 400px;
  }
  @media (min-width: 768px) {
    height: 620px;
  }
  @media (min-width: 1600px) {
    height: 700px;
  }
  @media print {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: white;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
  }
`;

const LessionContainer = styled.div`
  align-items: stretch;
  display: flex;
  flex-direction: column;
  margin: 0px auto;
  max-width: 1320px;
  padding: 64px 0px 0px;
  position: relative;
  width: 100%;
  justify-content: center;
  align-items: center;
  @media (min-width: 997px) {
    flex-direction: row;
    padding: 0px 30px;
  }
`;
const ButtonContainer = styled.button`
  background-color: transparent;
  border: none;
  color: ${COLOR.black600};
  cursor: pointer;
  height: 40px;
  left: ${(p) => `${p.left}px`};
  outline: none;
  position: absolute;
  right: ${(p) => `${p.right}px`};
  top: 50%;
  transition: all 300ms ease;
  width: 40px;
  z-index: 1;
`;


const ParentContainer = styled.div`
    // max-height: ${({ isStudent }) => (isStudent ? "885px" : "793px")};
    height: ${({ isEmpty, isStudent }) => (isEmpty && !isStudent ? "793px" : "885px")};
    overflow-y: ${({ isEmpty }) => (isEmpty ? "auto" : "auto")};
    overflow-x: hidden;
    padding-bottom: 12px;
    ::before {
    content: "";
    position: absolute;   
    margin: 0px;
    padding: 0px;
  }

    @media (max-width: 500px) {
        /* You can add specific styles for mobile here */
        /* Example:
        height: ${({ isEmpty, isStudent }) => (isEmpty && !isStudent ? "auto" : "auto")};
        overflow: ${({ isEmpty }) => (isEmpty ? "unset" : "unset")}; */
    }

    ${({ currentFullScreen }) =>
    !currentFullScreen &&
    `
        @media screen and (max-width: 808px) {
            overflow: unset !important;
            min-height: 50vh !important;
            padding-bottom: 100px !important;
            max-height: unset !important;
            height: unset !important;
        }
    `}
`;
const PrintWrapper = styled.div``;

const LinkContainer = styled.div`
  margin-top: 10px;
  background-color: ${COLOR.green100};
  padding: 8px;
  border-radius: 4px;
  &.fade-enter {
    opacity: 0;
    transform: translateY(-10px);
  }
  &.fade-enter-active {
    opacity: 1;
    transform: translateY(0);
    transition:
      opacity 300ms,
      transform 300ms;
  }
  &.fade-exit {
    opacity: 1;
    transform: translateY(0);
  }
  &.fade-exit-active {
    opacity: 0;
    transform: translateY(-10px);
    transition:
      opacity 300ms,
      transform 300ms;
  }
`;

const LinkItem = styled.div`
  margin-bottom: 5px;
  color: #fff;
  white-space: pre-line;
`;
const LinksItem = styled.a`
  color: #fff;
  text-decoration: none;
  background-color: transparent;
  outline: none;
  cursor: pointer;
  transition: color 0.3s;
  font-size: 14px;
  &:hover {
    color: ${COLOR.white};
  }
  &:before {
    display: inline-block;
    content: '';
    -webkit-border-radius: 0.375rem;
    border-radius: 0.375rem;
    height: 0.55rem;
    width: 0.55rem;
    margin-right: 0.5rem;
    background-color: #fff;
  }
`;

const StyledFormControlLabel = muiStyled(FormControlLabel)(({ theme }) => ({
  margin: "5px",
  '& .MuiFormControlLabel-label': {
    textTransform: "uppercase",
  },
  '&.teacher-stag': {
    margin: '5px',
  }
}));

const StyledSwitch = muiStyled(Switch)({
  '&.MuiSwitch-sizeSmall': {
    width: "40px",
    height: "25px",
  },
  '& .Mui-checked': {
    transform: "translateX(17px) !important",
  }
});
const TestGenerator = styled.button`
    width: 100%;
    max-width: 100%;
    height: auto;
    min-height: 35.16px;
    max-height: 35.16px;
    border-radius: 18px;
    background: #002d75;
    cursor: pointer;
    color: white;
    flex: 1 1 0%;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 2px;
`;
//  ----------------------------------------------------------------------------
//  Feature
//  ----------------------------------------------------------------------------
//
//  Ebook tooling
//
//  -- Description
//  Ebook student tooling
//
//  -- Props
//  ...
//
//  -- State
//  ...
//
//  -- Methods
//  ...
//
//  -- Usage
//  ...
//
const EbookTooling = ({
  isMatchMakingAssignment,
  setIsMatchMakingAssignment,
  classUsers,
  activity,
  activities,
  chapter,
  classActivities,
  classQuizzes,
  currentClass,
  currentUser,
  interactions,
  limit,
  notes,
  page,
  quiz,
  quizzes,
  data,
  ebookFlag,
  setEbookFlag,
  ebookFlagTeacherEdition,
  setEbookFlagTeacherEdition,
  submissions,
  tips,
  existTeacherEdition,
  existShowAnswer,
  existAssignmentLink,
  showCopyRight,
  showSpecialSupport,
  setShowSpecialSupport,
  setStudentViewFlag,
  handleImagePrint,
  setSubmitRef,
  timeInt,
  timmer,
  onFinish,
  onPageChage = () => null,
  printLoader,
  lessonPlan,
  rubrics,
  assignmentPlan,
  workbook_plan,
  main_book,
  booksAllList,
  pageSrc,
  book,
  learnPlanModals,
  setLearnPlanModals,
  links,
  pageHyperlink,
  dataBook,
  aiModals,
  setAiModals,
  page_1game_ai_content,
  imageConfiguration = {},
  isExam,
  isStandardExam,
  sentenceStarterData,
  handleOpenStoryWithAi = () => { },
  hasStoryWithAi,
  handlerOpenPresentation = () => { },
  page_slide,
  handleGenerateAiAssignment = () => { },
  is_non_roman,
  setToolsDropdown
}) => {
  const { openEngageModalTeacher = {} } = useUI();
  const showAlert = useAlert();
  const listWorkSheet = useWorkSheetSelector();
  const getHiddenBooks = get(currentClass, "hide_books", []).map(data => data?.bookId) || [];
  const deviceType = useMobileDeviceDetection();
  const navigate = useNavigate();
  const servertime = useServertime();
  const timezone = useOrgTimezone();
  const { listenToSentenceData } = useShareNotification();
  const standards = useStandards();
  const orgPermissions = useCurrentOrgPermission();
  const enabledStateCodes = useOrgStandardCodes();
  const classTogglePermission = useClassTogglePermission();
  const bookOrder = useBookOrder();
  const dispatch = useDispatch();
  const [customAssignmentDrawer, setCustomAssignmentDrawer] = useState(false);
  const [assignmentBuilderOpen, setAssignmentBuilderOpen] = useState(false);
  const [assignmentBuilderSeed, setAssignmentBuilderSeed] = useState(null);
  const [ebookFlagPageLink, setEbookFlagPageLink] = useState(false);
  const [preview, setPreview] = useState(false);
  const [assignmentData, setAssignmentData] = useState({});
  const [learnPlanModal, setLearnPlanModal] = useState(false);
  const [assignmentPlanModal, setAssignmentPlanModal] = useState(false);
  const [unitExamPlanModal, setUnitExamPlanModal] = useState(false);
  const [showDraggable, setShowDraggable] = useState(false);
  const [showAllNotes, setShowAllNotes] = useState(false);
  const [studyModals, setStudyModals] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const isStudent = currentUser && currentUser.role === "student";
  const isTeacher = currentUser && currentUser?.role === "teacher";
  const isDistrictAdmin = currentUser && currentUser?.role === "admin";
  const [openGraphicAssignmentPrivew, setOpenGraphicAssignmentPrivew] = useState(false)
  const [graphicAssignment, setGraphicAssignment] = useState({})
  const exams = useExams();
  const { isDrawerOpen, openDrawer, closeDrawer, toggleDrawer } = useSideDrawer();
  const isOnlyForTeacher = !!book?.onlyTeacher
  const isAdditionalBook = useIsAdditionalBook(chapter);
  const assignmentAllRefs = useRef(null);

  const dataList = listWorkSheet?.filter((item) => item?.page_id == page && item?.book_id == chapter);
  const currentPageIndex = useMemo(() => {
    const pages = data?.content || [];
    return pages.findIndex(p => p.pageId == page);
  }, [page, data?.content]);
  const hasLessionPlanPage = useMemo(() => {
    if (!lessonPlan || !data?.content) return null;
    const pages = data.content;
    return find(lessonPlan, (p) => {
      if (p.from && p.to) {
        const fromIndex = pages.findIndex(x => x.pageId == p.from);
        const toIndex = pages.findIndex(x => x.pageId == p.to);
        return currentPageIndex >= fromIndex && currentPageIndex <= toIndex && fromIndex >= 0 && toIndex >= 0;
      }
      return p.page == page;
    });
  }, [lessonPlan, currentPageIndex, data?.content, page]);
  const lessonPlanBook = hasLessionPlanPage
    ? find(booksAllList, (p) => p.id == hasLessionPlanPage.resourceId)
    : null;
  const lessionPlanPages = get(lessonPlanBook, "pages", []);
  const [lessonPageindex, setLessionPageindex] = useState(0);
  const [lessionPrintLoader, setlessionPrintLoader] = useState(false);
  const isTablate = useTabletDetection();
  const isMobile = useMobileDetect() && !isTablate;
  const { currentFullScreen, FullScreenMode, ExitFullScreenMode } = useFullScreen();
  // Sentence Starter
  const [sentenceData, setSentenceData] = useState({});
  const isSentenceStarterAllowedForBookGroup = useMemo(() => {
    if (!isStudent) return true;
    if (!classTogglePermission.sentence_starters) return true; // Default to allowed if no restrictions

    const currentBookGroup = bookOrder?.find((order) => order.order && order.order.includes(chapter));
    if (!classTogglePermission?.sentence_starters || Object.keys(classTogglePermission.sentence_starters).length === 0) {
      return false;
    }
    if (!has(classTogglePermission.sentence_starters, currentBookGroup?.key || isAdditionalBook?.key)) return true;

    if (isAdditionalBook?.key) {
      if (orgPermissions[isAdditionalBook?.key]) {
        return classTogglePermission.sentence_starters[isAdditionalBook?.key];
      }
    }

    return classTogglePermission.sentence_starters[currentBookGroup?.key];
  }, [isStudent, bookOrder, chapter, classTogglePermission?.sentence_starters, isAdditionalBook, orgPermissions]);
  //EbookTooling Full Screen Mode
  const { matchMakingView } = useMatchMakingView();


  // rubrics plan
  const hasRubricsPlanPage = useMemo(() => {
    if (!rubrics || !data?.content) return null;
    const pages = data.content;
    return find(rubrics, (p) => {
      if (p.from && p.to) {
        const fromIndex = pages.findIndex(x => x.pageId == p.from);
        const toIndex = pages.findIndex(x => x.pageId == p.to);
        return currentPageIndex >= fromIndex && currentPageIndex <= toIndex && fromIndex >= 0 && toIndex >= 0;
      }
      return p.page == page;
    });
  }, [rubrics, currentPageIndex, data?.content, page]);
  const rubricsPlanBook = hasRubricsPlanPage
    ? find(booksAllList, (p) => p.id == hasRubricsPlanPage.resourceId)
    : null;
  const rubricsPlanPages = get(rubricsPlanBook, "pages", []);
  const [rubricsPageindex, setRubricsPageindex] = useState(0);
  const [rubricsPrintLoader, setRubricsPrintLoader] = useState(false);
  const [rubricsPlanModal, setRubricsPlanModal] = useState(false);

  const hasAssignmentPlanPage = useMemo(() => {
    if (!assignmentPlan) return null;
    return find(assignmentPlan, (p) => p.page == page);
  }, [assignmentPlan, page]);
  const assignmentPlanBook = hasAssignmentPlanPage
    ? find(booksAllList, (p) => p.id == hasAssignmentPlanPage.resourceId)
    : null;
  const assignmentPlanPages = get(assignmentPlanBook, "pages", []);
  const [assignmentPageindex, setAssignmentPageindex] = useState(0);
  const [assignmentPrintLoader, setAssignmentPrintLoader] = useState(false);

  const hasUnitExamPlanPage = useMemo(() => {
    if (!book?.unit_exam) return null;
    return find(book?.unit_exam, (p) => p.page == page);
  }, [book?.unit_exam, page]);

  const unitExamPlanBook = hasUnitExamPlanPage
    ? find(booksAllList, (p) => p.id == hasUnitExamPlanPage.resourceId)
    : null;

  const unitExamPlanPages = get(unitExamPlanBook, "pages", []);
  const [unitExamPageIndex, setUnitExamPageindex] = useState(0);
  const [unitExamPrintLoader, setUnitExamPrintLoader] = useState(false);

  //workbook plan
  const hasWorkbookPlanPage = useMemo(() => {
    if (!workbook_plan || !data?.content) return null;
    const pages = data.content;
    return find(workbook_plan, (p) => {
      if (p.from && p.to) {
        const fromIndex = pages.findIndex(x => x.pageId == p.from);
        const toIndex = pages.findIndex(x => x.pageId == p.to);
        return currentPageIndex >= fromIndex && currentPageIndex <= toIndex && fromIndex >= 0 && toIndex >= 0;
      }
      return p.page == page;
    });
  }, [workbook_plan, currentPageIndex, data?.content, page]);
  const WorkbookPlanBook = hasWorkbookPlanPage
    ? find(booksAllList, (p) => p.id == hasWorkbookPlanPage.resourceId)
    : null;
  const WorkbookPlanPages = get(WorkbookPlanBook, "pages", []);
  const [WorkbookPageindex, setWorkbookPageindex] = useState(0);
  const [workbookPlanModal, setWorkbookPlanModal] = useState(false);

  // ---------------- Answer ------------------------------
  const answer_page = filter(dataBook?.pagesTeacher, (item) => parseInt(item.pageId) === parseInt(page))

  // ---------------- PDF ------------------------------
  const pdf_page = find(dataBook?.pagesPDF, (item) => parseInt(item.pageId) === parseInt(page))

  //main book
  const hasMain_bookPage = useMemo(() => {
    if (!main_book || !data?.content) return null;
    const pages = data.content;
    return find(main_book, (p) => {
      if (p.from && p.to) {
        const fromIndex = pages.findIndex(x => x.pageId == p.from);
        const toIndex = pages.findIndex(x => x.pageId == p.to);
        return currentPageIndex >= fromIndex && currentPageIndex <= toIndex && fromIndex >= 0 && toIndex >= 0;
      }
      return p.page == page;
    });
  }, [main_book, currentPageIndex, data?.content, page]);
  const mainBook = hasMain_bookPage
    ? find(booksAllList, (p) => p.id == hasMain_bookPage.resourceId)
    : null;
  const mainBookPages = get(mainBook, "pages", []);
  const { invokeMainbookView } = useMainbookView();
  const { invokeAnswerView, revokeAnswerView } = useAnswerView();
  const { pdfView, invokePDFView, revokePDFView } = usePDFView();
  const { activityStandardsView, invokeActivityStandardsView, revokeActivityStandardsView } = useActivityStandardsView();
  const { checkPopUpAtOnce, updatePopUpAtOnce,openPopUpAtOnce } = usePopUpAtOnce();


  const [alertSakeBar, setAlertSakeBar] = useState({
    open: false,
    message: "",
  });
  const findAssignmentLink = existAssignmentLink?.find((assignmentLink) => parseInt(assignmentLink?.page) === parseInt(page));
  const [teacher_strategies, setTeacherStrategies] = useState(false);
  const learningModuleCount = useLearningModuleCount();
  const {engage} = useBookDataUnits(chapter,page, book?.engage)
  const {checkStandardExamBookType} = useIsExamActive({bookId: chapter});

  const newMaskId = get(
    find(get(data, "content"), (k) => k.pageId == page),
    "numberMasked",
    page
  );

  const pageLearningModuleCount = useMemo(() => {
    return learningModuleCount?.result?.find(item => String(item?.page) === String(page));
  }, [learningModuleCount, page]);

  const hasteacherEdition = useMemo(
    () => get(orgPermissions, "teacherEdition", true),
    [orgPermissions]
  );

  // ------new logic -------//
  const isAssessmentBook = useMemo(
    () => book && book.is_assessment_book,
    [book]
  );
  const bookData = useMemo(() => getBookData(
    activities,
    quizzes,
    null,
    notes,
    null,
    interactions,
    classActivities,
    classQuizzes,
    chapter,
    currentClass.id,
    isAssessmentBook,
    currentUser.id
  ), [activities, quizzes, notes, interactions, classActivities, classQuizzes, chapter, currentClass, isAssessmentBook, currentUser]);
  const disableAssignment = isAssessmentBook;
  const hasAllAssignButton = false;
  const isEntireExamAssigned =
    bookData.activities.length == bookData.classActivities.length &&
    bookData.quizzes?.length == bookData.classQuizzes.length;
  const remainingActivity = filter(
    bookData.activities,
    (activity) =>
      find(
        bookData.classActivities,
        (classActivity) => classActivity.activityId == activity.id
      ) == undefined
  );
  const remainingQuiz = filter(
    bookData.quizzes,
    (quiz) =>
      find(bookData.classQuizzes, (classQuiz) => classQuiz.quizId == quiz.id) ==
      undefined
  );
  const pageData = getPageData(
    bookData,
    page,
    quiz,
    activity,
    isAssessmentBook
  );
  const pageInteractions = pageData.pageInteractions;
  const videoSupport = pageData.videoSupport;
  const pageNotes = pageData.pageNotes;
  const availableActivity = modifyAssignmentForStudent(
    pageData.availableActivity,
    isStudent,
    false,
    currentUser,
    servertime,
    timezone,
    currentClass,
    getHiddenBooks
  );
  const modAssignableActivity = pageData.assignableActivity;

  const assignableActivity = useMemo(() => {
    const data = sortByCustomType(modAssignableActivity);
    const xyz = data?.filter((x) => x?.type?.toLowerCase() !== "custom");

    const sortedActivities = [...xyz].sort((a, b) => {
      const seqA = parseInt(a.sequence_order) || 0;
      const seqB = parseInt(b.sequence_order) || 0;
      return seqA - seqB;
    });

    const finalResult = [
      ...sortedActivities,
      ...data?.filter((x) => x?.type?.toLowerCase() === "custom"),
    ];
    return finalResult;
  }, [modAssignableActivity]);

  const activeActivity = pageData.activeActivity;
  const availableQuiz = modifyAssignmentForStudent(
    pageData.availableQuiz,
    isStudent,
    true,
    currentUser,
    servertime,
    timezone,
    currentClass,
    getHiddenBooks
  );
  const modAssignableQuiz = pageData.assignableQuiz;
  const assignableQuiz = useMemo(() => {
    const data = sortByCustomType(modAssignableQuiz);
    const xyz = data?.filter((x) => x?.type?.toLowerCase() !== "custom");

    const sortedActivities = [...xyz].sort((a, b) => {
      const seqA = parseInt(a.sequence_order) || 0;
      const seqB = parseInt(b.sequence_order) || 0;
      return seqA - seqB;
    });

    const finalResult = [
      ...sortedActivities,
      ...data?.filter((x) => x?.type?.toLowerCase() === "custom"),
    ];
    return finalResult;
  }, [modAssignableQuiz]);


  const activeQuiz = pageData.activeQuiz;
  
  const hasActivitiesWithStandards = useMemo(() => {
    const allActivities = [...(assignableActivity || []), ...(availableActivity || []), ...(assignableQuiz || []), ...(availableQuiz || [])];
    const uniqueActivities = [];
    const seenIds = new Set();
    
    allActivities.forEach(activity => {
      const dataId = get(activity, 'data.id');
      const activityId = get(activity, 'activityId');
      const wrapperId = get(activity, 'id');
      const finalId = dataId || activityId || wrapperId;
      
      if (finalId && !seenIds.has(finalId)) {
        seenIds.add(finalId);
        uniqueActivities.push(activity);
      }
    });
    
    const activitiesWithStandards = uniqueActivities.filter(activity => {
      const questionsDirect = get(activity, 'questions', []);
      const questionsNested = get(activity, 'data.questions', []);
      const questions = Array.isArray(questionsDirect) && questionsDirect.length > 0 ? questionsDirect : (Array.isArray(questionsNested) ? questionsNested : []);
      if (!Array.isArray(questions) || questions.length === 0) return false;
      
      return questions.some(q => {
        if (!q || !q.state_standard || !Array.isArray(q.state_standard)) return false;
        const filteredStateStandards = filterStateStandardByEnabledStates(q.state_standard, enabledStateCodes);
        return filteredStateStandards.some(ss => ss && ss.standard && Array.isArray(ss.standard) && ss.standard.length > 0);
      });
    });
    
    return activitiesWithStandards.length > 0;
  }, [assignableActivity, availableActivity, assignableQuiz, availableQuiz, bookData, page, enabledStateCodes]);

  const hasActivitiesOrQuizzes = useMemo(() => {
    const pageActivities = filter(bookData.activities, (activity) => {
      const activityPage = get(activity, 'page') || get(activity, 'data.page');
      return String(activityPage) === String(page);
    });
    const pageQuizzes = filter(bookData.quizzes || [], (quiz) => {
      const quizPage = get(quiz, 'page') || get(quiz, 'data.page');
      return String(quizPage) === String(page);
    });
    const assignableActivityLength = assignableActivity?.length || 0;
    const availableActivityLength = availableActivity?.length || 0;
    const assignableQuizLength = assignableQuiz?.length || 0;
    const availableQuizLength = availableQuiz?.length || 0;
    const pageActivitiesLength = pageActivities?.length || 0;
    const pageQuizzesLength = pageQuizzes?.length || 0;
    
    return assignableActivityLength > 0 || availableActivityLength > 0 || assignableQuizLength > 0 || availableQuizLength > 0 || pageActivitiesLength > 0 || pageQuizzesLength > 0;
  }, [assignableActivity, availableActivity, assignableQuiz, availableQuiz, bookData, page]);

  const allActivitiesForStandards = useMemo(() => {
    const allActivities = [...(assignableActivity || []), ...(availableActivity || []), ...(assignableQuiz || []), ...(availableQuiz || [])];
    const uniqueActivities = [];
    const seenIds = new Set();
    
    allActivities.forEach(activity => {
      const dataId = get(activity, 'data.id');
      const activityId = get(activity, 'activityId');
      const wrapperId = get(activity, 'id');
      const finalId = dataId || activityId || wrapperId;
      
      if (finalId && !seenIds.has(finalId)) {
        seenIds.add(finalId);
        uniqueActivities.push(activity);
      }
    });
    
    const filtered = uniqueActivities.filter(activity => {
      const questionsDirect = get(activity, 'questions', []);
      const questionsNested = get(activity, 'data.questions', []);
      const questions = Array.isArray(questionsDirect) && questionsDirect.length > 0 ? questionsDirect : (Array.isArray(questionsNested) ? questionsNested : []);
      if (!Array.isArray(questions) || questions.length === 0) return false;
      
      return questions.some(q => {
        if (!q || !q.state_standard || !Array.isArray(q.state_standard)) return false;
        return q.state_standard.some(ss => ss && ss.standard && Array.isArray(ss.standard) && ss.standard.length > 0);
      });
    });
    
    return filtered;
  }, [assignableActivity, availableActivity, assignableQuiz, availableQuiz, bookData, page]);

  const backBtnRef = useRef(null);
  const forwardBtnRef = useRef(null);
  const isDemo = currentUser?.demo || false;
  const isReviewAccount = currentUser?.reviewAccount || false;
  const sentece_id = `admin_sentence-${import.meta.env.VITE_APP_STAGE?.trim() === "prod" ? "prod" : "dev"}`
  const onDeleteGetAssignment = async () => {
    // await dispatch(handleListActivities());
    // await dispatch(handleListQuizzes());
    // await dispatch(handleListCustomAssignment(get(currentUser, "role"), get(currentUser, "id")))
  };

  useEffect(() => {
    const unsubscribe = listenToSentenceData(sentece_id, (data) => {
      setSentenceData(data?.[sentece_id]);
    });
    return () => unsubscribe();
  }, []);

  useEffect(() => {
    onPageChage(onPageSwipe);
  }, [onPageChage]);
  useEffect(() => {
    document.addEventListener("keydown", checkKey);
    return () => {
      document.removeEventListener("keydown", checkKey);
    };
  }, []);



  let infoClassUSers = filter(classUsers, (x) => x.role === "student");
  let listStudents = [];
  for (var u in infoClassUSers) {
    listStudents.push({
      id: infoClassUSers[u].id,
      description: `${infoClassUSers[u].lastName}  ${infoClassUSers[u].firstName} (${infoClassUSers[u].username})`,
    });
  }

  const tipsTalented = filter(tips, (x) => x.texType === "talented");
  const tipsSpecial = filter(tips, (x) => x.texType === "special");

  const existSpecialSupport = useMemo(() => videoSupport && videoSupport.length > 0, [videoSupport]);

  let existStudentView = false;
  if (availableActivity.length || availableQuiz.length > 0) {
    existStudentView = true;
  }


  const closeAssignment = () => {
    navigate(
      `/ebook?chapter=${chapter}&page=${page}&activity=null&quiz=null`
    );
  };

  const [expanded, setExpanded] = React.useState("panel1");


  const setFlagsShowAnswer = (flag) => {
    setEbookFlagTeacherEdition(false);
    setEbookFlag(flag);
    setStudentViewFlag(false);
    if (flag === false) {
      revokeAnswerView();
    }
  };

  const setFlagsTeacherEdition = (flag) => {
    setEbookFlagTeacherEdition(flag);
    setEbookFlag(false);
    // revokeAnswerView();
    setStudentViewFlag(false);
  };

  const setShowStudentView = (flag) => {
    setStudentViewFlag(flag);
    setEbookFlag(false);
    setEbookFlagTeacherEdition(false);
  };



  const assignmentPreivew = (assignment) => {
    try {
      const assignmentData = assignment.data ? assignment.data : assignment
      if (assignmentData.activity_type === "graphic_organizer") {
        setOpenGraphicAssignmentPrivew(true)
        setGraphicAssignment(assignmentData)
      } else {
        setAssignmentData(assignment.data ? assignment.data : assignment)
        setPreview(true)
      }
    } catch (error) {
      Sentry.captureException(`520 Error in assignmentPreivew: ${error}`);
    }
  }
  const onPageSwipe = () => {
    setPreview(false);
    setAssignmentData({});
  };
  const getSrcPage = () => {
    if (lessionPlanPages) {
      const page = lessionPlanPages[lessonPageindex];
      return page ? page.resource : null;
    }
  };
  const getSrcAssignmentPage = () => {
    if (assignmentPlanModal) {
      if (assignmentPlanPages) {
        const page = assignmentPlanPages[assignmentPageindex];
        return page ? page.resource : null;
      }
    } else {
      if (unitExamPlanPages) {
        const page = unitExamPlanPages[unitExamPageIndex];
        return page ? page.resource : null;
      }
    }

  };
  const getSrcWorkbookPage = () => {
    if (
      WorkbookPageindex >= 0 &&
      WorkbookPlanPages &&
      WorkbookPlanPages.length > 0
    ) {
      const page = WorkbookPlanPages[WorkbookPageindex];
      return page ? page.resource : null;
    }
  };
  const getSrcRubricsPage = () => {
    if (rubricsPlanPages) {
      const page = rubricsPlanPages[rubricsPageindex];
      return page ? page.resource : null;
    }
  };

  const getHrefTitle = (link) => {
    if (typeof link == 'string') {
      return link;
    } else if (typeof link == 'object') {
      return link.title && link.title.length > 0 ? link.title : link.href;
    } else {
      return '';
    }
  };

  const imageRef = useRef();
  const handlePrint = () => {
    if (imageRef.current) {
      imageRef.current.classList.add("printable")
    }
    handleLessionImagePrint()
  }
  const handleLessionImagePrint = useReactToPrint({
    contentRef: imageRef,
    onBeforeGetContent: async () => {
      setlessionPrintLoader(true);
      setAssignmentPrintLoader(true);
      setRubricsPrintLoader(true);
      setUnitExamPrintLoader(true);
    },
    onBeforePrint: async () => {
      setlessionPrintLoader(false);
      setAssignmentPrintLoader(false);
      setRubricsPrintLoader(false);
      setUnitExamPrintLoader(false);
    },
    onAfterPrint: async () => {
      setlessionPrintLoader(false);
      setAssignmentPrintLoader(false);
      setRubricsPrintLoader(false);
      setUnitExamPrintLoader(false);
      imageRef.current.classList.remove("printable")
    },
  });
  const handlePrintLessons = () => {
    if (isMobile || isTablate) {
      showAlert("Print is not supported on this device!", "error");
      return;
    }
    else {
      handlePrint();
    }
  };
  function checkKey(e) {
    let isLessonPlan =
      document.getElementsByClassName("lessonPlanPopUp").length > 0;
    let isRubricsPlan =
      document.getElementsByClassName("rubricsPopUp").length > 0;
    if (isLessonPlan || isRubricsPlan) {
      e = e || window.event;
      if (e.keyCode == "37") {
        if (backBtnRef.current && !backBtnRef.current.disabled) {
          backBtnRef.current.click();
        }
      } else if (e.keyCode == "39") {
        if (forwardBtnRef.current && !forwardBtnRef.current.disabled) {
          forwardBtnRef.current.click();
        }
      }
    }
  }
  const closeAlert = () => {
    setAlertSakeBar({ open: false, message: "" });
  };
  const hasActiveAssignmentDrawer = () => {
    const quizSubmissions = parseInt(
      get(
        find(submissions, ["assignmentId", activeQuiz?.data.id]),
        "submissions",
        0
      )
    );
    const quizRetake = parseInt(get(activeQuiz, "retakes", 0));
    const activitySubmissions = parseInt(
      get(
        find(submissions, ["assignmentId", activeActivity?.data.id]),
        "submissions",
        0
      )
    );
    const activityRetatke = parseInt(get(activeActivity, "retakes", 0)) + 1;

    if (
      (typeof quiz == "string" && quiz.length > 2 && quiz !== "null") ||
      (typeof activity == "string" &&
        activity.length > 2 &&
        activity !== "null")
    ) {
      return (
        quizSubmissions < quizRetake || activitySubmissions < activityRetatke
      );
    } else {
      return false;
    }
  };
  const isStudentTakingAssignment = useMemo(() => {
    if (!isStudent) return false;
    return (
      (typeof quiz === "string" && quiz.length > 2 && quiz !== "null") ||
      (typeof activity === "string" && activity.length > 2 && activity !== "null")
    );
  }, [isStudent, quiz, activity]);
  const redirectToMainBook = () => {
    const redirectTO = {
      page: findAssignmentLink?.from,
      chapter: findAssignmentLink?.resourceId,
    };
    // const activitiesAndQuizzes = [
    //   availableActivity,
    //   assignableActivity,
    //   availableQuiz,
    //   assignableQuiz,
    //   activeQuiz,
    //   activeActivity,
    // ].find((activity) => activity && activity[0]);
    // let hasRedirectTo = null;
    // let assignment_data = null;
    // if (activitiesAndQuizzes) {
    //   hasRedirectTo = get(activitiesAndQuizzes[0], "redirectTo");
    //   assignment_data = activitiesAndQuizzes[0];
    // }
    // if (hasRedirectTo && typeof hasRedirectTo === "object") {
    //   redirectTO.chapter = hasRedirectTo.chapter;
    //   redirectTO.page = hasRedirectTo.page;
    // } else if (assignment_data) {
    //   redirectTO.chapter =
    //     assignment_data.chapter || assignment_data.data.chapter;
    //   redirectTO.page = assignment_data.page || assignment_data.data.page;
    // }
    navigate(
      `/ebook?chapter=${redirectTO.chapter}&page=${redirectTO.page}&activity=null&quiz=null`
    );
  };
  const onBookClick = async () => {
    if (checkPopUpAtOnce()) {
      return;
    }
    const mainBookFromIndex = findIndex(
      mainBookPages,
      (p) => p.pageId == get(hasMain_bookPage, "from", 0)
    );
    const mainBookTo = findIndex(
      mainBookPages,
      (p) => p.pageId == get(hasMain_bookPage, "to", 0)
    );
    if (mainBookFromIndex >= 0 && mainBookTo >= 0) {
      const main_book_pages = Array.isArray(mainBookPages)
        ? mainBookPages.slice(mainBookFromIndex, mainBookTo + 1)
        : [];
      invokeMainbookView(main_book_pages);
      updatePopUpAtOnce(true);
    }
  };

  const onWorkBookClick = async () => {
    if (checkPopUpAtOnce()) {
      return;
    }
    if (workbookPlanFromIndex >= 0 && workbookPlanTo >= 0) {
      const main_work_book_pages = Array.isArray(WorkbookPlanPages)
        ? WorkbookPlanPages.slice(workbookPlanFromIndex, workbookPlanTo + 1)
        : [];
      invokeMainbookView(main_work_book_pages);
      updatePopUpAtOnce(true);
    }
  }

  const onAnswerClick = () => {
    if (checkPopUpAtOnce()) {
      return;
    }
    updatePopUpAtOnce(true);
    invokeAnswerView(answer_page);
  }

  const onPDFClick = () => {
    if (checkPopUpAtOnce()) {
      return;
    }
    updatePopUpAtOnce(true);
    invokePDFView(pdf_page);
  }

  const lessionPlanFromIndex = useMemo(() => {
    if (!hasLessionPlanPage || !lessionPlanPages?.length) return -1;
    return findIndex(lessionPlanPages, p => p.pageId == get(hasLessionPlanPage, "from", 0));
  }, [hasLessionPlanPage, lessionPlanPages]);
  
  const lessionPlanTo = useMemo(() => {
    if (!hasLessionPlanPage || !lessionPlanPages?.length) return -1;
    return findIndex(lessionPlanPages, p => p.pageId == get(hasLessionPlanPage, "to", 0));
  }, [hasLessionPlanPage, lessionPlanPages]);

  const assignmentPlanFromIndex = useMemo(() => {
    if (!hasAssignmentPlanPage || !assignmentPlanPages?.length) return -1;
    return findIndex(assignmentPlanPages, p => p.pageId == get(hasAssignmentPlanPage, "from", 0));
  }, [hasAssignmentPlanPage, assignmentPlanPages]);
  
  const assignmentPlanTo = useMemo(() => {
    if (!hasAssignmentPlanPage || !assignmentPlanPages?.length) return -1;
    return findIndex(assignmentPlanPages, p => p.pageId == get(hasAssignmentPlanPage, "to", 0));
  }, [hasAssignmentPlanPage, assignmentPlanPages]);

  const unitExamPlanFromIndex = useMemo(() => {
    if (!hasUnitExamPlanPage || !unitExamPlanPages?.length) return -1;
    return findIndex(unitExamPlanPages, p => p.pageId == get(hasUnitExamPlanPage, "from", 0));
  }, [hasUnitExamPlanPage, unitExamPlanPages]);
  
  const unitExamPlanTo = useMemo(() => {
    if (!hasUnitExamPlanPage || !unitExamPlanPages?.length) return -1;
    return findIndex(unitExamPlanPages, p => p.pageId == get(hasUnitExamPlanPage, "to", 0));
  }, [hasUnitExamPlanPage, unitExamPlanPages]);

  const workbookPlanFromIndex = useMemo(() => {
    if (!hasWorkbookPlanPage || !WorkbookPlanPages?.length) return -1;
    return findIndex(WorkbookPlanPages, p => p.pageId == get(hasWorkbookPlanPage, "from", 0));
  }, [hasWorkbookPlanPage, WorkbookPlanPages]);
  
  const workbookPlanTo = useMemo(() => {
    if (!hasWorkbookPlanPage || !WorkbookPlanPages?.length) return -1;
    return findIndex(WorkbookPlanPages, p => p.pageId == get(hasWorkbookPlanPage, "to", 0));
  }, [hasWorkbookPlanPage, WorkbookPlanPages]);

  const rubricsPlanFromIndex = useMemo(() => {
    if (!hasRubricsPlanPage || !rubricsPlanPages?.length) return -1;
    return findIndex(rubricsPlanPages, p => p.pageId == get(hasRubricsPlanPage, "from", 0));
  }, [hasRubricsPlanPage, rubricsPlanPages]);
  
  const rubricsPlanTo = useMemo(() => {
    if (!hasRubricsPlanPage || !rubricsPlanPages?.length) return -1;
    return findIndex(rubricsPlanPages, p => p.pageId == get(hasRubricsPlanPage, "to", 0));
  }, [hasRubricsPlanPage, rubricsPlanPages]);

  const onBubbleNotesClick = () => {
    setShowDraggable((prevState) => !prevState);
  };
  const handleSeeAllNotesClick = () => {
    setShowAllNotes(!showAllNotes);
  };
  const notesData = [
    { page: "Page. 70", title: "Los cognados Falsos" },
    { page: "Page. 70", title: "Title" },
    { page: "Page. 70", title: "Title" },
    { page: "Page. 70", title: "Title" },
    { page: "Page. 70", title: "Title" },
    { page: "Page. 70", title: "Title" },
    { page: "Page. 70", title: "Title" },
    { page: "Page. 70", title: "Title" },
  ];
  const handleBackClick = () => {
    setShowAllNotes(false);
  };
  const onSaveAndClose = () => {
    setShowDraggable(!showDraggable);
  };

  let isEmpty;
  if (!isStudent) {
    isEmpty =
      pageInteractions?.length === 0 &&
      videoSupport.length === 0 &&
      tipsTalented.length === 0 &&
      tipsSpecial.length === 0 &&
      availableActivity?.length === 0 &&
      assignableActivity?.length === 0 &&
      availableQuiz?.length === 0 &&
      assignableQuiz.length === 0 &&
      dataList?.length === 0;
  } else {
    isEmpty =
      pageInteractions?.length === 0 &&
      videoSupport.length === 0 &&
      tipsTalented.length === 0 &&
      tipsSpecial.length === 0 &&
      availableQuiz?.length === 0 &&
      availableActivity?.length === 0 && dataList?.length === 0;
  }


  const handleForDistrictAdmin = () => {
    if (currentUser.role === 'admin') {
      showAlert('Please login as teacher!', "error")
      return true;
    }
    return false;
  }

  const handleOpenStoryAi = () => {
    if (handleForDistrictAdmin()) return;
    handleOpenStoryWithAi();
  }

  const examBookIdss = exams?.flatMap((entry) =>
    entry.exams.map((exam) => `${exam.bookId}`)
  );



  return (
  <SentryWrap>
    <div className="eBookTolScrn">
      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        open={alertSakeBar.open}
        autoHideDuration={3000}
        onClose={closeAlert}
      >
        <Alert
          onClose={() => {
            setAlertSakeBar({ open: false, message: "" });
          }}
          severity="error"
        >
          <strong>ALERT:</strong> {alertSakeBar.message}
        </Alert>
      </Snackbar>

      {/* workSheetModal for teachers  */}
      <TeachersWorkSheet setIsOpen={setIsOpen} isOpen={isOpen} book_id={chapter} page_id={page} numberMasked={newMaskId} />
      {/* end of workSheetModal  */}
      <Modal
        open={learnPlanModals}
        onClose={() => {
          setLearnPlanModal(false);
          setLearnPlanModals(false);
        }}
        className={"lessonPlanPopUp"}
        style={{
          height: "100%",
          width: "100%",
          backgroundColor: "transparent",
        }}
      >
        <LearnPlanWrapper>
          <LessionPlanContainer>
            <CloseBtn
              onClick={() => {
                setLearnPlanModal(false);
                setLessionPageindex(0);
                setLearnPlanModals(false);
              }}
            >
              <Close
                style={{ color: "#fff", fontWeight: "bolder", fontSize: 25 }}
              />
            </CloseBtn>
            <div
              style={{
                position: "absolute",
                right: "40px",
                top: "0px",
                zIndex: "1",
              }}
            >
              <LessionPlanPrinter
                onPrintSingle={handlePrintLessons}
                printLoader={lessionPrintLoader}
                images={slice(
                  lessionPlanPages,
                  lessionPlanFromIndex > 0 ? lessionPlanFromIndex : 0,
                  lessionPlanTo
                )
                  .map((k) => k.resource)
                  .filter((k) => k)}
              />
            </div>
            {lessonPageindex > lessionPlanFromIndex && (
              <ButtonContainer
                ref={backBtnRef}
                disabled={lessonPageindex <= lessionPlanFromIndex}
                onClick={() => {
                  setLessionPageindex(lessonPageindex - 1);
                }}
                left={0}
              >
                <ArrowBackIos style={{ fontSize: "40px" }} />
              </ButtonContainer>
            )}
            {lessonPageindex < lessionPlanTo && (
              <ButtonContainer
                ref={forwardBtnRef}
                disabled={lessonPageindex >= lessionPlanTo}
                onClick={() => {
                  setLessionPageindex(lessonPageindex + 1);
                }}
                right={0}
              >
                <ArrowForwardIos style={{ fontSize: "40px" }} />
              </ButtonContainer>
            )}
            <LessionContainer>
              <PrintWrapper ref={imageRef}>
                <Images src={getSrcPage()} />
              </PrintWrapper>
            </LessionContainer>
          </LessionPlanContainer>
        </LearnPlanWrapper>
      </Modal>
      <Modal
        open={assignmentPlanModal}
        onClose={() => setAssignmentPlanModal(true)}
        className={"lessonPlanPopUp"}
        style={{
          height: "100%",
          width: "100%",
          backgroundColor: "transparent",
        }}
      >
        <LearnPlanWrapper>
          <LessionPlanContainer>
            <CloseBtn
              onClick={() => {
                setAssignmentPlanModal(false);
                setAssignmentPageindex(0);
              }}
            >
              <Close
                style={{ color: "#fff", fontWeight: "bolder", fontSize: 25 }}
              />
            </CloseBtn>

            <IconButton
              onClick={handlePrintLessons}
              aria-label="print"
              style={{
                position: "absolute",
                right: "40px",
                top: "0px",
                zIndex: "1",
              }}
              disabled={assignmentPrintLoader}
            >
              {assignmentPrintLoader ? <Loading size={20} /> : <PrintIcon />}
            </IconButton>
            {assignmentPageindex > assignmentPlanFromIndex && (
              <ButtonContainer
                ref={backBtnRef}
                disabled={assignmentPageindex <= assignmentPlanFromIndex}
                onClick={() => {
                  setAssignmentPageindex(assignmentPageindex - 1);
                }}
                left={0}
              >
                <ArrowBackIos style={{ fontSize: "40px" }} />
              </ButtonContainer>
            )}
            {assignmentPageindex < assignmentPlanTo && (
              <ButtonContainer
                ref={forwardBtnRef}
                disabled={assignmentPageindex >= assignmentPlanTo}
                onClick={() => {
                  setAssignmentPageindex(assignmentPageindex + 1);
                }}
                right={0}
              >
                <ArrowForwardIos style={{ fontSize: "40px" }} />
              </ButtonContainer>
            )}
            <LessionContainer>
              <PrintWrapper ref={imageRef}>
                <Images src={getSrcAssignmentPage()} />
              </PrintWrapper>
            </LessionContainer>
          </LessionPlanContainer>
        </LearnPlanWrapper>
      </Modal>

      {/* unit exam */}
      <Modal
        open={unitExamPlanModal}
        onClose={() => setUnitExamPlanModal(false)}
        className={"lessonPlanPopUp"}
        style={{
          height: "100%",
          width: "100%",
          backgroundColor: "transparent",
        }}
      >
        <LearnPlanWrapper>
          <LessionPlanContainer>
            <CloseBtn
              onClick={() => {
                setUnitExamPlanModal(false);
                setUnitExamPageindex(0);
              }}
            >
              <Close
                style={{ color: "#fff", fontWeight: "bolder", fontSize: 25 }}
              />
            </CloseBtn>

            <IconButton
              onClick={handlePrintLessons}
              aria-label="print"
              style={{
                position: "absolute",
                right: "40px",
                top: "0px",
                zIndex: "1",
              }}
              disabled={unitExamPrintLoader}
            >
              {unitExamPrintLoader ? <Loading size={20} /> : <PrintIcon />}
            </IconButton>
            {unitExamPageIndex > unitExamPlanFromIndex && (
              <ButtonContainer
                ref={backBtnRef}
                disabled={unitExamPageIndex <= unitExamPlanFromIndex}
                onClick={() => {
                  setUnitExamPageindex(unitExamPageIndex - 1);
                }}
                left={0}
              >
                <ArrowBackIos style={{ fontSize: "40px" }} />
              </ButtonContainer>
            )}
            {unitExamPageIndex < unitExamPlanTo && (
              <ButtonContainer
                ref={forwardBtnRef}
                disabled={unitExamPageIndex >= unitExamPlanTo}
                onClick={() => {
                  setUnitExamPageindex(unitExamPageIndex + 1);
                }}
                right={0}
              >
                <ArrowForwardIos style={{ fontSize: "40px" }} />
              </ButtonContainer>
            )}
            <LessionContainer>
              <PrintWrapper ref={imageRef}>
                <Images src={getSrcAssignmentPage()} />
              </PrintWrapper>
            </LessionContainer>
          </LessionPlanContainer>
        </LearnPlanWrapper>
      </Modal>

      {/* rubrics plan modal */}

      <Modal
        open={rubricsPlanModal}
        onClose={() => setRubricsPlanModal(true)}
        className={"rubricsPopUp"}
        style={{
          height: "100%",
          width: "100%",
          backgroundColor: "transparent",
        }}
      >
        <LearnPlanWrapper>
          <LessionPlanContainer>
            <CloseBtn
              onClick={() => {
                setRubricsPlanModal(false);
                setRubricsPageindex(0);
              }}
            >
              <Close
                style={{ color: "#fff", fontWeight: "bolder", fontSize: 25 }}
              />
            </CloseBtn>

            <IconButton
              onClick={handlePrintLessons}
              aria-label="print"
              style={{
                position: "absolute",
                right: "40px",
                top: "0px",
                zIndex: "1",
              }}
              disabled={rubricsPrintLoader}
            >
              {rubricsPrintLoader ? <Loading size={20} /> : <PrintIcon />}
            </IconButton>
            {rubricsPageindex > rubricsPlanFromIndex && (
              <ButtonContainer
                ref={backBtnRef}
                disabled={rubricsPageindex <= rubricsPlanFromIndex}
                onClick={() => {
                  setRubricsPageindex(rubricsPageindex - 1);
                }}
                left={0}
              >
                <ArrowBackIos style={{ fontSize: "40px" }} />
              </ButtonContainer>
            )}
            {rubricsPageindex < rubricsPlanTo && (
              <ButtonContainer
                ref={forwardBtnRef}
                disabled={rubricsPageindex >= rubricsPlanTo}
                onClick={() => {
                  setRubricsPageindex(rubricsPageindex + 1);
                }}
                right={0}
              >
                <ArrowForwardIos style={{ fontSize: "40px" }} />
              </ButtonContainer>
            )}
            <LessionContainer>
              <PrintWrapper ref={imageRef}>
                <Images src={getSrcRubricsPage()} />
              </PrintWrapper>
            </LessionContainer>
          </LessionPlanContainer>
        </LearnPlanWrapper>
      </Modal>
      {/* end of rubrics plan */}

      {/* Workbook plan modal start */}
      <Modal
        open={workbookPlanModal}
        onClose={() => setWorkbookPlanModal(true)}
        className={"lessonPlanPopUp"}
        style={{
          height: "100%",
          width: "100%",
          backgroundColor: "transparent",
        }}
      >
        <LearnPlanWrapper>
          <LessionPlanContainer>
            <CloseBtn
              onClick={() => {
                setWorkbookPlanModal(false);
                setWorkbookPageindex(0);
              }}
            >
              <Close
                style={{ color: "#fff", fontWeight: "bolder", fontSize: 25 }}
              />
            </CloseBtn>

            {/* <IconButton onClick={handlePrintLessons} aria-label="print"
                            style={{ position: "absolute", right: "40px", top: "0px", zIndex: "1" }}
                            disabled={assignmentPrintLoader}>
                            {assignmentPrintLoader ? <Loading size={20} /> : <PrintIcon />}
                        </IconButton> */}
            {WorkbookPageindex > workbookPlanFromIndex && (
              <ButtonContainer
                ref={backBtnRef}
                disabled={WorkbookPageindex <= workbookPlanFromIndex}
                onClick={() => {
                  setWorkbookPageindex(WorkbookPageindex - 1);
                }}
                left={0}
              >
                <ArrowBackIos style={{ fontSize: "40px" }} />
              </ButtonContainer>
            )}
            {WorkbookPageindex < workbookPlanTo && (
              <ButtonContainer
                ref={forwardBtnRef}
                disabled={WorkbookPageindex >= workbookPlanTo}
                onClick={() => {
                  setWorkbookPageindex(WorkbookPageindex + 1);
                }}
                right={0}
              >
                <ArrowForwardIos style={{ fontSize: "40px" }} />
              </ButtonContainer>
            )}
            <LessionContainer>
              <PrintWrapper ref={imageRef}>
                <Images src={getSrcWorkbookPage()} />
              </PrintWrapper>
            </LessionContainer>
          </LessionPlanContainer>
        </LearnPlanWrapper>
      </Modal>
      {/* Workbook plan modal end */}
     {customAssignmentDrawer?<AssignmentForm
        open={customAssignmentDrawer}
        onClose={() => {
          setCustomAssignmentDrawer(false);
          setAssignmentBuilderSeed(null);
        }}
        bookId={chapter}
        pageId={page}
        pageSrc={pageSrc}
        ai_questions={assignmentBuilderSeed?.ai_questions}
        assignmentTitle={assignmentBuilderSeed?.assignmentTitle}
      />:null}
      {assignmentBuilderOpen && <AssignmentBuilderTool
        open={assignmentBuilderOpen}
        onClose={() => setAssignmentBuilderOpen(false)}
        data={data}
        page={page}
        chapter={chapter}
        from="ebook"
        pageSrc={pageSrc}
        disableSubmit={Boolean(isExam || isStandardExam || checkStandardExamBookType)}
        generatedTest
      />}
      <Row
        span={17}
        style={{
          display: "flex",
          justifyContent: "flex-end",
          alignItems: "center",
        }}
        className="ebookMobleView btnContSpacing tolingSection"
      >
        {isDrawerOpen && <Close onClick={closeDrawer}
          style={{ color: "red", fontWeight: "bolder", fontSize: 35, position: 'absolute', top: 0, left: 0, cursor: "pointer"  }}
        />}
        {/* <TimmerWrapper>
          {timeInt !== 0 && currentUser?.role == "student" ? timeInt : ""}
        </TimmerWrapper> */}
        <PlannerWrapper className="tolingSectionAddOn">
          
          {!preview && isTeacher && (!isOnlyForTeacher && !isExam) && !checkStandardExamBookType && (
            <>
              <AssignmentPlan
                className='ebooks-button'
                onClick={() => setCustomAssignmentDrawer(true)}
              //     style={{ color: "white",
              //     height: 27.2, backgroundColor:"#01989E",fontSize: "10px",
              //     width:85, marginRight: '4px', fontWeight:"700"

              // }}
              >
                <AssignmentPlanInner><Add style={{ fontSize: '13px', fontWeight: 700 }} /> Assignment</AssignmentPlanInner>
              </AssignmentPlan>

            </>
          )}
          {isStudent && <DummyBtn></DummyBtn>}
          {/* {hasLessionPlanPage && currentUser?.role !== "student" ? (
            <LessionPlan
              onClick={() => {
                if(checkPopUpAtOnce()){
                  return;
                }
                if (get(orgPermissions, "lessonPlan", true)) {
                  setLearnPlanModal(true);
                  setLessionPageindex(lessionPlanFromIndex);
                } else {
                  setAlertSakeBar({
                    open: true,
                    message: "Restricted access (legend)",
                  });
                }
              }}
            >
              <LessionPlanInner>{hasLessionPlanPage?.levelTitle?.length > 0 ? hasLessionPlanPage?.levelTitle : "Lesson Plan"}  </LessionPlanInner>
            </LessionPlan>
          ) : null} */}
          <LessonPlan imageRef={imageRef} pageId={page} lessonPlanData={lessonPlan} handlePrintLessons={handlePrintLessons} lessionPrintLoader={lessionPrintLoader} setLearnPlanModals={setLearnPlanModal} learnPlanModals={learnPlanModal} chapter={chapter} data={data} />
          {sentenceData?.id && isSentenceStarterAllowedForBookGroup && (
            <SentenceViewTooling pageId={page} sentenceStarterData={sentenceStarterData} book={book} />
          )}
          {hasMain_bookPage && currentUser?.role === "teacher" ? (
            <AssignmentPlan onClick={onBookClick}>
              <AssignmentPlanInner>Assessment Book</AssignmentPlanInner>
            </AssignmentPlan>
          ) : null}
          {hasWorkbookPlanPage && currentUser?.role !== "student" ? (
            <AssignmentPlan
              onClick={onWorkBookClick}
            >
              <AssignmentPlanInner>Workbook</AssignmentPlanInner>
            </AssignmentPlan>
          ) : null}
          <QuizHandler
            states={{
              // this for quiz
              hasAssignmentPlanPage, currentUser, assignmentPlanFromIndex,
              //this for unit quiz
              hasUnitExamPlanPage, unitExamPageIndex
            }}
            funcObj={{ setAssignmentPlanModal, setAssignmentPageindex, setUnitExamPageindex, setUnitExamPlanModal }}
          />
          {/* {hasAssignmentPlanPage && currentUser?.role !== "student" ? (
            <AssignmentPlan
              onClick={() => {
                setAssignmentPlanModal(true);
                setAssignmentPageindex(assignmentPlanFromIndex);
              }}
            >
              <AssignmentPlanInner>Quiz</AssignmentPlanInner>
            </AssignmentPlan>
          ) : null} */}
          {hasRubricsPlanPage && currentUser?.role !== "student" ? (
            <AssignmentPlan
              onClick={() => {
                if (checkPopUpAtOnce()) {
                  return;
                }
                setRubricsPlanModal(true);
                setRubricsPageindex(rubricsPlanFromIndex);
              }}
            >
              <AssignmentPlanInner>Rubrics</AssignmentPlanInner>
            </AssignmentPlan>
          ) : null}
        </PlannerWrapper>
      </Row>

      <Wrapper style={{ minHeight: imageConfiguration?.clientHeight }} className="ebokToolUpr maintainHeight">
        <Toolbar>
          {/* Buttons */}

          <Row className="ebookBtnView">
            <Col
              span={5}
              style={{
                display: "flex",
                justifyContent: "flex-start",
                alignItems: "center",
              }}
            >
              <Page style={{ color: "#ffffff" }}>
                {!isStudent ? <PrintAction isDemo={isDemo} isReviewAccount={isReviewAccount} handleImagePrint={handleImagePrint} printLoader={printLoader} chapter={chapter} pageId={page} from={"ebook"} alow_print_section={false} images={data.content || []} pageSrc={pageSrc} /> : null}
                P.
                {openEngageModalTeacher?.engageName ? (
                  <EngagePgEditor name={openEngageModalTeacher?.engageName}  engage={engage}/>
                ) : (
                  <PageEditor
                  activity={activity}
                  chapter={chapter}
                  limit={limit}
                  page={page}
                  numberMasked={newMaskId}
                  content={data?.content}
                  quiz={quiz}
                  value={page}
                />
                )}
              </Page>
            </Col>

            {/* <Col
              span={2}
              style={{
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "center",
              }}
            > */}

            <div className='seticonsDiv'>
             {
              currentUser?.role === "student" && (
                isDrawerOpen ? (
                <FullscreenExitIcon  sx={{ color: 'white', fontSize: '41px', cursor: 'pointer' }} onClick={toggleDrawer} />
              ) : (
                <FullscreenIcon sx={{ color: 'white', fontSize: '41px', cursor: 'pointer' }} onClick={toggleDrawer} />
              )
             )
             }
             <BubbleNotes
                pageSrc={pageSrc}
                data={data}
                page={page}
                newMaskNote={newMaskId}
                currentUser={currentUser}
                pageNotes={pageNotes}
                chapter={chapter}
                dataBook={dataBook}
              />
            </div>


            {/* </Col> */}
          </Row>
        </Toolbar>
        {/* <LinkList links={links} /> */}
        {/* Toogles buttons */}
        {isStudent && (
          <div className="mt-10px">
            <Wrap className="ebokToolWrap ebokToolWrapNwCstm 111">
              <div className="setWdthSwitch setWdthSwitchFullRow">
                <ExtensionActivitiesTooling pageId={page} />
              </div>
              <div className='toggleEnSp toggleEnSpNwDesign setWdthSwitch'><CommonEbookTooling bookId={chapter} pageId={page} /></div>
            </Wrap>
          </div>
        )}

        {!isStudent && (
          <div className="mt-10px">
            <Wrap className="ebokToolWrap ebokToolWrapNwCstm 222" empty={!(existTeacherEdition && hasteacherEdition) && !existSpecialSupport && !(existShowAnswer || existStudentView) && !links && !(tips?.length > 0)}>

              <div className="setWdthSwitch setWdthSwitchFullRow">
                <ExtensionActivitiesTooling pageId={page} />
              </div>
              <div className='setWdthSwitch'><LinkList links={pageHyperlink} ebookFlagTeacherEdition={ebookFlagTeacherEdition} ebookFlagPageLink={ebookFlagPageLink} setEbookFlagPageLink={(val) => {
                setEbookFlagPageLink(val);
                setFlagsTeacherEdition(false);
              }} /></div>

              {existTeacherEdition && hasteacherEdition && (
                <div className='setWdthSwitch'>
                  <TeacherEditionList booksAllList={booksAllList} page={page} dataBook={dataBook} links={links} ebookFlagTeacherEdition={ebookFlagTeacherEdition} setFlagsTeacherEdition={(value) => {
                    setFlagsTeacherEdition(value)
                    setEbookFlagPageLink(false)
                    setToolsDropdown(false)
                  }} />
                </div>
              )}
              {/*{existTeacherEdition && hasteacherEdition && (
                <StyledFormControlLabel
                  control={
                    <StyledSwitch
                      checked={ebookFlagTeacherEdition}
                      onChange={(e) => setFlagsTeacherEdition(e.target.checked)}
                      name="viewTeacherEdition"
                      color="primary"
                      size="small"
                    />
                  }
                  label="Teacher Edition"
                />
              )} */}
              {existShowAnswer && (
                <div className='setWdthSwitch'>
                  <StyledFormControlLabel
                    control={
                      <StyledSwitch
                        checked={ebookFlag}
                        onChange={(e) => {
                          setToolsDropdown(false);
                          if (e.target.checked) {
                              // if(openPopUpAtOnce){ 
                              //   checkPopUpAtOnce();
                              //     return;
                              // }
                              onAnswerClick()
                              setFlagsShowAnswer(e.target.checked)
                              setToolsDropdown(false)
                          }
                          else if(!e.target.checked) {
                          updatePopUpAtOnce(false);
                          revokeAnswerView()
                          setFlagsShowAnswer(e.target.checked)
                          setToolsDropdown(false)
                      }
                        }}
                        name="viewFlag"
                        color="primary"
                        size="small"
                      />
                    }
                    label="Show Answers"
                  />
                </div>
              )}
              {pdf_page && currentUser?.role === 'teacher' && (
                <div className='setWdthSwitch'>
                  <StyledFormControlLabel
                    control={
                      <StyledSwitch
                        checked={pdfView.open}
                        onChange={async (e) => {
                          setToolsDropdown(false);
                          if (e.target.checked) {
                            if (checkPopUpAtOnce()) {
                              return;
                            }
                            onPDFClick()
                          }
                          else if(!e.target.checked) {
                            updatePopUpAtOnce(false);
                            revokePDFView();
                          }
                        }}
                        name="viewPDF"
                        color="primary"
                        size="small"
                      />
                    }
                    label="View as PDF"
                  />
                </div>
              )}

              {existSpecialSupport && (
                <div className='setWdthSwitch'>
                  <StyledFormControlLabel
                    control={
                      <StyledSwitch
                        checked={showSpecialSupport}
                        onChange={(e) => setShowSpecialSupport(e.target.checked)}
                        name="viewSpecialSupport"
                        color="primary"
                        size="small"
                      />
                    }
                    label="Additional support"
                  />
                </div>
              )}

              {tips?.length > 0 && (
                <div className='setWdthSwitch'>
                  <StyledFormControlLabel
                    className="teacher-stag"
                    control={
                      <StyledSwitch
                        checked={teacher_strategies}
                        onChange={e => {
                          if(e.target.checked){
                            if(checkPopUpAtOnce()){ 
                              return;
                            }
                            updatePopUpAtOnce(true);
                            setExpanded('panel2')
                            setTeacherStrategies(e.target.checked)
                          }else{
                            setExpanded('panel2')
                            setTeacherStrategies(e.target.checked)
                            updatePopUpAtOnce(false);
                          }
                       
                        }}
                        name="viewTeacherEdition"
                        color="primary"
                        size="small"
                      />
                    }
                    label="Teacher strategies"
                  />
                </div>
              )}

            <div className='toggleEnSp toggleEnSpNwDesign setWdthSwitch'><CommonEbookTooling bookId={chapter} pageId={page} /></div>
            </Wrap>
          </div>
        )}
        




        {!isStudentTakingAssignment && (
        <div className="gameStudyCollectUpr">
          {!isExam && (
            <>
            <div className="gameStudyCollect 22">
              {/* Bingo Modal */}
              {!isStudent && !isExam && (
                  <BingoModal page={page} chapter={chapter} newMaskId={newMaskId} pageLearningModuleCount={pageLearningModuleCount} />
              )}
              {(isTeacher || isDistrictAdmin) && (
                  <OnegameModals
                    aiModal={aiModals}
                    setAiModal={setAiModals}
                    booksAllList={booksAllList}
                    chapter={chapter}
                    page={page}
                    currentClass={currentClass}
                    currentUser={currentUser}
                    page_1game_ai_content={page_1game_ai_content}
                    bookUnits={data?.structures}
                    newMaskId={newMaskId}
                  />
              )}
              
                <OnestudyModals
                  aiModal={studyModals}
                  setAiModal={setStudyModals}
                  booksAllList={booksAllList}
                  chapter={chapter}
                  page={page}
                  currentClass={currentClass}
                  currentUser={currentUser}
                  page_1game_ai_content={page_1game_ai_content}
                  bookUnits={data?.structures}
                  newMaskId={newMaskId}
                />
              

              {/* Soy Historas */}
              {(isTeacher || isDistrictAdmin) && (
                <div className='vocOrGame' style={{ display: 'flex', alignItems: 'center', justifyContent: get(currentUser, "role") === "student" ? '' : 'center' }} >
                
                  <button onClick={() => handleOpenStoryAi()} className='addOneImg'>
                    <Badge
                  overlap="rectangular"
                  badgeContent={
                    pageLearningModuleCount && 
                    pageLearningModuleCount.soy_historias_status && 
                    Array.isArray(hasStoryWithAi) && 
                    hasStoryWithAi.filter(item => !isErrorContent(item?.story_content || '')).length > 0
                      ? "✓" 
                      : undefined
                  }
                  color="success"
                  variant="standard"
                  sx={{width: '100%'}}
                >
                    <img src={SoyHistoriasIconUpdated} alt='SoyHistorias' title='SoyHistorias' />
                    </Badge>
                  </button>
                
                </div>
              )}
              {/* Soy Historias for Students - with count */}
              {isStudent && Array.isArray(hasStoryWithAi) && hasStoryWithAi.filter(item => !isErrorContent(item?.story_content || '')).length > 0 && (
                <div className='vocOrGame' style={{ display: 'flex', alignItems: 'center', justifyContent: get(currentUser, "role") === "student" ? '' : 'center' }} >
                
                
                  <button onClick={() => handleOpenStoryWithAi()} className='addOneImg'>
                  <Badge
                    overlap="rectangular"
                    badgeContent={
                      pageLearningModuleCount && 
                      pageLearningModuleCount.soy_historias_status && 
                      Array.isArray(hasStoryWithAi) && 
                      hasStoryWithAi.filter(item => !isErrorContent(item?.story_content || '')).length > 0
                        ? "✓" 
                        : undefined
                    }
                    color="success"
                    variant="standard"
                    sx={{width: '100%'}}
                  >
                    <img src={SoyHistoriasIconUpdated} alt='SoyHistorias' title='SoyHistorias' />
                  </Badge>
                  </button>
                </div>
              )}

              
              {!isStudent && !isOnlyForTeacher &&
                (
                  <div className='vocOrGame' style={{ display: 'flex', alignItems: 'center', justifyContent: get(currentUser, "role") === "student" ? '' : 'center' }} >
                  
                    <button onClick={() => {
                      if (checkPopUpAtOnce()) {
                        return;
                      }
                      updatePopUpAtOnce(true);
                      if (handleForDistrictAdmin()) return;
                      setIsOpen(true)
                    }} className='addOneImg' style={{ backgroundColor: 'transparent' }}>
                      <Badge
                    overlap="rectangular"
                    badgeContent={pageLearningModuleCount && pageLearningModuleCount.worksheet_status ? "✓" : undefined}
                    color="success"
                    variant="standard"
                    sx={{width: '100%'}}
                  >
                      <img src={GrammerIconDrill} alt="Grammar Drills" title="Grammar Drills" />
                      
                  </Badge>
                    </button>
                  </div>
                )

              }

              {
                Boolean(page_slide && page_slide.id) && (
                  <>
                      <div className="vocOrGame" style={{ display: "flex", justifyContent: "center" }}>
                        <button onClick={handlerOpenPresentation} className="addOneImg">
                          <Badge
                            overlap="rectangular"
                            badgeContent={"✓"}
                            color="success"
                            variant="standard"
                            sx={{ width: "100%" }}
                          >
                            <img
                              src={PresentationIcon}
                              alt="Presentation"
                            />
                          </Badge>
                        </button>
                      </div>
                    </>
                )
              }

              {
                !isStudent && !isOnlyForTeacher && !is_non_roman && (
                  <>
                      <div className="vocOrGame" style={{ display: "flex", justifyContent: "center" }}>
                        <button
                          onClick={handleGenerateAiAssignment}
                          className="addOneImg"
                          style={{ flex: 1 }}
                        >
                          <img
                            src={AiActivityIcon}
                            alt="Ai Activity"
                          />
                        </button>
              
                      </div>
                    </>

                )
              }

              {
                (() => {
                  const hasShowStandards =
                    hasActivitiesWithStandards && !isStudent && !isOnlyForTeacher;
                  
                    const showStandardsButton = () => (
                      <button 
                        onClick={async () => {
                          if (openPopUpAtOnce) {
                            checkPopUpAtOnce();
                            return;
                          }
                          if (activityStandardsView.open) {
                            updatePopUpAtOnce(false);
                            revokeActivityStandardsView();
                          } else {
                            updatePopUpAtOnce(true);
                            const units = data?.structures || [];
                            const pages = data?.content || [];
                            invokeActivityStandardsView(
                              allActivitiesForStandards,
                              standards,
                              enabledStateCodes,
                              bookData,
                              units,
                              pages,
                              page
                            );
                          }
                        }}
                        className='addOneImg' style={{ backgroundColor: 'transparent' }}>
                      <Badge
                        overlap="rectangular"
                        badgeContent={activityStandardsView.open ? "✓" : undefined}
                        color="success"
                        variant="standard"
                        sx={{width: '100%'}}
                      >
                          <img
                            src={ShowStandardIcon}
                            alt="Show Standards"
                          />
                      </Badge>
                    </button>
                    );
                  
                  if (hasShowStandards) {
                    return (
                      <div className='vocOrGame' style={{ display: 'flex', alignItems: 'center', justifyContent: 'center'}} >
                        {showStandardsButton()}
                      </div>
                    );
                  }
                  return null;
                })()
              }
                

              {/* {(() => {
                const hasPresentation =
                Boolean(page_slide && page_slide.id);
                const hasAiActivity =
                  !isStudent && !isOnlyForTeacher && !is_non_roman;
                const hasShowStandards =
                  hasActivitiesWithStandards && !isStudent && !isOnlyForTeacher;
              
                const showStandardsButton = () => (
                  <button 
                    onClick={async () => {
                      if (openPopUpAtOnce) {
                        checkPopUpAtOnce();
                        return;
                      }
                      if (activityStandardsView.open) {
                        updatePopUpAtOnce(false);
                        revokeActivityStandardsView();
                      } else {
                        updatePopUpAtOnce(true);
                        const units = data?.structures || [];
                        const pages = data?.content || [];
                        invokeActivityStandardsView(
                          allActivitiesForStandards,
                          standards,
                          enabledStateCodes,
                          bookData,
                          units,
                          pages,
                          page
                        );
                      }
                    }}
                    className='addOneImg' style={{ backgroundColor: 'transparent' }}>
                  <Badge
                    overlap="rectangular"
                    badgeContent={activityStandardsView.open ? "✓" : undefined}
                    color="success"
                    variant="standard"
                    sx={{width: '100%'}}
                  >
                      <img
                        src={ShowStandardIcon}
                        alt="Show Standards"
                      />
                  </Badge>
                </button>
                );
                if (hasPresentation && hasAiActivity && hasShowStandards) {
                  return (
                    <>
                      <div className="vocOrGame" style={{ display: "flex", justifyContent: "center" }}>
                        <button onClick={handlerOpenPresentation} className="addOneImg">
                          <Badge
                            overlap="rectangular"
                            badgeContent={"✓"}
                            color="success"
                            variant="standard"
                            sx={{ width: "100%" }}
                          >
                            <img
                              src={PresentationIcon}
                              alt="Presentation"
                            />
                          </Badge>
                        </button>
                      </div>
              
                      <div style={{ display: "flex", width: "100%", gap: "9px" }}>
                        <button
                          onClick={handleGenerateAiAssignment}
                          className="addOneImg"
                          style={{ flex: 1 }}
                        >
                          <img
                            src={AiActivityIcon}
                            alt="Ai Activity"
                          />
                        </button>
              
                        <div style={{ flex: 1 }}>{showStandardsButton()}</div>
                      </div>
                    </>
                  );
                }
                if (hasPresentation && hasAiActivity && !hasShowStandards) {
                  return (
                    <>
                      <div className='vocOrGame' style={{ display: 'flex', alignItems: 'center', justifyContent: get(currentUser, "role") === "student" ? '' : 'center' }} >
                        <button 
                          onClick={() => handlerOpenPresentation()} 
                          className='addOneImg'>
                          <Badge
                            overlap="rectangular"
                            badgeContent={"✓"}
                            color="success"
                            variant="standard"
                            sx={{width: '100%'}}
                          >
                            <img src={PresentationIcon} alt="Presentation" title="Presentation" />
                          </Badge>
                        </button>
                      </div>
                      <button onClick={handleGenerateAiAssignment} className="addOneImg">
                        <img
                          src={AiActivityIcon}
                          alt="Ai Activity"
                        />
                      </button>
                    </>
                  );
                }
                if (hasPresentation && !hasAiActivity && hasShowStandards) {
                  return (
                    <>
                      <div className='vocOrGame' style={{ display: 'flex', alignItems: 'center', justifyContent: get(currentUser, "role") === "student" ? '' : 'center' }} >
                        <button
                          onClick={() => handlerOpenPresentation()}
                          className='addOneImg'>
                          <Badge
                            overlap="rectangular"
                            badgeContent={"✓"}
                            color="success"
                            variant="standard"
                            sx={{ width: '100%' }}
                          >
                            <img src={PresentationIcon} alt="Presentation" title="Presentation" />
                          </Badge>
                        </button>
                      </div>
                      <div className='vocOrGame' style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%' }} >
                        {showStandardsButton()}
                      </div>
                    </>
                  );
                }
                if (hasPresentation && !hasAiActivity && !hasShowStandards && !isStudent) {
                  return (
                    <div className='vocOrGame' style={{ display: 'flex', alignItems: 'center', justifyContent: get(currentUser, "role") === "student" ? '' : 'center' }} >
                      <button 
                        onClick={() => handlerOpenPresentation()} 
                        className='addOneImg'>
                        <Badge
                          overlap="rectangular"
                          badgeContent={"✓"}
                          color="success"
                          variant="standard"
                          sx={{width: '100%'}}
                        >
                          <img src={PresentationIcon} alt="Presentation" title="Presentation" />
                        </Badge>
                      </button>
                    </div>
                  );
                }
                if (!hasPresentation && hasAiActivity && hasShowStandards) {
                  return (
                    <>
                      <div className='vocOrGame' style={{ display: 'flex', alignItems: 'center', justifyContent: get(currentUser, "role") === "student" ? '' : 'center' }} >
                        <button 
                          onClick={handleGenerateAiAssignment} 
                          className='addOneImg'
                        >
                          <img src={AiActivityIcon} alt="Ai Activity" title="Ai Activity" />
                        </button>
                      </div>
                      <div className='vocOrGame' style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%' }} >
                        {showStandardsButton()}
                      </div>
                    </>
                  );
                }
                if (!hasPresentation && hasAiActivity && !hasShowStandards) {
                  return (
                    <div className='vocOrGame' style={{ display: 'flex', alignItems: 'center', justifyContent: get(currentUser, "role") === "student" ? '' : 'center' }} >
                      <button 
                        onClick={handleGenerateAiAssignment} 
                        className='addOneImg'
                      >
                        <img src={AiActivityIcon} alt="Ai Activity" title="Ai Activity" />
                      </button>
                    </div>
                  );
                }
                if (!hasPresentation && !hasAiActivity && hasShowStandards) {
                  return (
                    <div className='vocOrGame' style={{ display: 'flex', alignItems: 'center', justifyContent: get(currentUser, "role") === "student" ? '' : 'center' }} >
                      {showStandardsButton()}
                    </div>
                  );
                }
                
                return null;
              })()} */}
              {!isStudent && 
              (
                <div className="vocOrGame" style={{ display: "flex", justifyContent: "center" }}>
                  <GraphicOrganizerAssignments page={page} chapter={chapter} isResource={true} />
                </div>
              )}
              
              {!isStudent && <GraphicAssignmentPreview open={openGraphicAssignmentPrivew} setOpen={setOpenGraphicAssignmentPrivew} assignment={graphicAssignment} page_id={page} bookId={chapter} />}

            </div>
            <div className="gameStudyCollect 22">
            {!isStudent && !isOnlyForTeacher && !isExam  && !isStandardExam&& (
              <div className="vocOrGame" style={{ display: 'flex', width: '100%', gap: '9px'}}>
                <TestGenerator
                  type="button"
                  onClick={() => {
                    if (handleForDistrictAdmin()) return;
                    setAssignmentBuilderOpen(true);
                  }}
                  className="addOneImg"
                  style={{ flex: 1 }}
                  title="Assignment Builder"
                >
                  <img src={GenerateTestIcon} alt="Generate Test" title="Generate Test" />
                </TestGenerator>
              </div>
            )}
            </div>
            </>
          
          )}


        </div>
        )}


        <ParentContainer
          currentFullScreen={currentFullScreen}
          className={`${isDrawerOpen ? "toolingSectionInDrawer" : ""
            } ${preview ? "disable-effects" : ""}`}
          style={{ maxHeight: imageConfiguration?.clientHeight - 0 }}
          isEmpty={isEmpty}
          isStudent={isStudent}
        >

          <TeacherStrategies showCopyRight={showCopyRight} teacher_strategies={teacher_strategies} tips={tips} />
          {pageInteractions?.length > 0 ? (
            <Section className={`playAudio audioIntra`}>
              {pageInteractions?.map((action, index) => (
                <Interaction key={action.id} data={action} pageId={page} chapter={chapter} index={index} />
              ))}
            </Section>
          ) : null}
          {isTeacher && existAssignmentLink?.length > 0 && (
            <SectionHeader style={{ marginLeft: '8px', marginBottom: '8px' }}>
              <AssignmentPlanLink onClick={redirectToMainBook}>
                {/* <AssignmentPlanInner>{`This quiz can be assigned from the ${findAssignmentLinkBook?.description}. Please click here be redirected`}</AssignmentPlanInner> */}
                <AssignmentPlanInnerLink>{`This quiz can be assigned from the Student Edition. Please click here be redirected.`}</AssignmentPlanInnerLink>
              </AssignmentPlanLink>
            </SectionHeader>
          )}
          <div
            style={{ paddingInline: "12px", backgroundColor: "#e0e0e0" }}
            className="ebookMobButton 111"
          >
            <VideoSupport showCopyRight={showCopyRight} showSpecialSupport={showSpecialSupport} videoSupport={videoSupport} />
            <Section className="assignAllRefCstm" ref={assignmentAllRefs}>
              <AssignmentsComponent
                bookId={chapter} pageId={page}
                student_render_assignments={true} from="ebook" isAssessmentBook={isAssessmentBook}
                assignmentAllRefs={assignmentAllRefs}
                onFinish={onFinish}
                setSubmitRef={setSubmitRef}
                timmer={timmer}
                timeInt={timeInt}
                toggleDrawer={toggleDrawer}
                closeSideDrawer={closeDrawer}
                isDrawerOpen={isDrawerOpen}
                currentBook={book}

                newMaskId={newMaskId}
                pageLearningModuleCount={pageLearningModuleCount}
                isStudentTakingAssignment={isStudentTakingAssignment}
              />
            </Section>
          </div>


        </ParentContainer>
      </Wrapper>
    </div>
    </SentryWrap>
  );
};





//  ----------------------------------------------------------------------------
//  Redux
//  ----------------------------------------------------------------------------
const mapStateToProps = (state) => ({
  activities: state.activities,
  classActivities: state.classActivities,
  classQuizzes: state.classQuizzes,
  currentClass: state.currentClass,
  currentOrg: state.currentOrg,
  currentUser: state.currentUser,
  interactions: state.interactions,
  notes: state.notes,
  quizzes: state.quizzes,
  submissions: state.submissions,
});

export default connect(mapStateToProps, null)(EbookTooling);